import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMonitoringToken } from '../../utils/monitoringIntent';

export default function StartMonitoring() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <main aria-busy="true">Preparing your monitoring project…</main>;
  if (isAuthenticated) return <Navigate to="/auth/continue" replace />;
  if (getMonitoringToken()) return <Navigate to="/register" replace />;
  return <main style={{ margin: '10vh auto', maxWidth: 480, padding: 24 }}>
    <h1>Your monitoring link is missing or expired</h1>
    <p><a href="https://lazysem.com/features/monitoring-service">Enter your URL again</a> to continue.</p>
    <p><a href="/login">Sign in to an existing account</a></p>
  </main>;
}
